import * as React from "react";

export const HistoryIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25">
    <path
      d="M11.99 2.23499C6.47 2.23499 2 6.71499 2 12.235C2 17.755 6.47 22.235 11.99 22.235C17.52 22.235 22 17.755 22 12.235C22 6.71499 17.52 2.23499 11.99 2.23499ZM12 20.235C7.58 20.235 4 16.655 4 12.235C4 7.81499 7.58 4.23499 12 4.23499C16.42 4.23499 20 7.81499 20 12.235C20 16.655 16.42 20.235 12 20.235ZM12.5 7.23499H11V13.235L16.25 16.385L17 15.155L12.5 12.485V7.23499Z"
      className="elm-fill-current elm-text-gray-500 elm-opacity-70"
    />
  </svg>
);
